import React from 'react';

function ShowDetail() {
  return (
    <div className="loader center">
      {/* <i className="fa fa-spinner fa-spin" style={{fontSize:'60px', marginLeft:'45%'}}/> */}
      <center>
      <h6>Loading Please Wait...</h6>
      </center>
    </div>
  );
}

export default ShowDetail;